import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import routes from '@/router/routes'

Vue.use( VueRouter )

const scrollBehavior = async ( to, from, savedPosition ) => {
  let target = 0
  
  if ( to.hash ) {
    target = to.hash
  } else if ( savedPosition ) {
    target = savedPosition.y
  }

  return await goTo( target )
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes,
})

export default router
